import { Component, OnInit, ViewChild } from '@angular/core'
import { Router } from '@angular/router'
import { NgForm } from '@angular/forms'
import { MatDialog, MatDialogConfig } from '@angular/material/dialog'
import { UntypedFormBuilder, FormControl, UntypedFormGroup } from '@angular/forms'

import { SiteService } from '../../../../services/site.service'
import { MessageService } from '../../../../services/message.service'
import { TranslateService } from '@ngx-translate/core'
import { CustomerRequestsService } from '../../../../services/customer-requests.service'

import { PhoneChangeViewModel } from '../../../../models/phoneChangeViewModel'
import { ErrorMessageModalComponent } from '../../../modals/error-message-modal/error-message-modal.component'

@Component({
    selector: 'app-request-phone-change-detail',
    templateUrl: './request-phone-change-detail.component.html',
    styleUrls: ['./request-phone-change-detail.component.scss'],
    standalone: false
})
export class RequestPhoneChangeDetailComponent implements OnInit 
{
  @ViewChild('customForm') public customForm!: NgForm

  customFormGroup!: UntypedFormGroup
  formSubmitted: boolean = false
  isActiveLease: boolean = true

	phoneNumberPattern = "^[0-9]{10,10}$"
  request =
  {
    homePhone: '',
    businessPhone: '',
    mobilePhone: '',
  }
  referenceNumber: string = ''
  phoneChangeViewModel = new PhoneChangeViewModel()

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private siteService: SiteService,
    private messageService: MessageService,
    private translateService: TranslateService,
    private formBuilder: UntypedFormBuilder,
    private customerRequestsService: CustomerRequestsService
  ) 
  { 
  }

  ngOnInit() 
  {
    this.retrievePhoneChangeViewModel()
  }

  retrievePhoneChangeViewModel()
  {
    this.messageService.startedHttpRequest('retrievePhoneAccountChangeViewModel')
    this.customerRequestsService
      .getPhoneChangeRequestViewModel()
			.subscribe({
				next: (apiResponse) =>
        {
          this.phoneChangeViewModel = apiResponse

          if(this.phoneChangeViewModel && this.phoneChangeViewModel.isActiveLease)
          {
              this.request.homePhone = this.phoneChangeViewModel.homePhone
              this.request.businessPhone = this.phoneChangeViewModel.businessPhone
              this.request.mobilePhone = this.phoneChangeViewModel.mobilePhone
          }
          else
          {
            this.isActiveLease = false
          }
        },
				error: (error) =>
				{
          this.isActiveLease = false
          this.messageService.completedHttpRequest('retrievePhoneAccountChangeViewModel')
      
          const dialogConfig = new MatDialogConfig()
          dialogConfig.width = '500px',
          dialogConfig.data = {
            title: this.translateService.instant('COMMON_LBL_ERROR'),
            message: this.translateService.instant('COMMON_LBL_ERROR_MSG')
          }		
          this.dialog.open(ErrorMessageModalComponent, dialogConfig)
				},
				complete: () =>
				{
					this.messageService.completedHttpRequest('retrievePhoneAccountChangeViewModel')
				}
			})
  }

  submitForm(customerForm: NgForm)
  {
    this.formSubmitted = true

    if (customerForm.invalid)
    {
      return
    }

    if(this.request.homePhone==this.phoneChangeViewModel.homePhone && 
      this.request.businessPhone==this.phoneChangeViewModel.businessPhone && 
      this.request.mobilePhone==this.phoneChangeViewModel.mobilePhone)
    {
        const dialogConfig = new MatDialogConfig()
        dialogConfig.width = '500px',
        dialogConfig.data = {
            title: '',
            message: this.translateService.instant('REQUEST_PHONE_CHANGE_ERR_SAME_INFO'),
        }		
        this.dialog.open(ErrorMessageModalComponent, dialogConfig)

        return
    }

    const requestSummaryList: { key: string; value: string }[] = [
      { key: this.translateService.instant('REQUEST_PHONE_CHANGE_CONFIRM_NAME'), value: this.siteService.customerAccount?.fullName ?? '' },
      { key: this.translateService.instant('REQUEST_PHONE_CHANGE_CONFIRM_LEASENUM'), value: this.phoneChangeViewModel.leaseNumber },
      { key: this.translateService.instant('REQUEST_PHONE_CHANGE_CONFIRM_HOME_PHONE'), value: this.request.homePhone },
      { key: this.translateService.instant('REQUEST_PHONE_CHANGE_CONFIRM_WORK_PHONE'), value: this.request.businessPhone },
      { key: this.translateService.instant('REQUEST_PHONE_CHANGE_CONFIRM_MOBILE_PHONE'), value: this.request.mobilePhone }
    ]

    return this.customerRequestsService.requestConfirmation(this.translateService.instant('REQUEST_PHONE_CHANGE_CONFIRM_PRINT_TITLE'), requestSummaryList)
    .then((result) =>
    {
      if(result)
      {
        let changeRequest =
				{
					homePhone: this.request.homePhone,
          businessPhone: this.request.businessPhone,
          mobilePhone: this.request.mobilePhone
				}

        this.messageService.startedHttpRequest('submitForm')
        this.customerRequestsService
        .addPhoneChangeRequest(changeRequest)
        .subscribe({
          next: (apiResponse) =>
          {
            this.referenceNumber = apiResponse

            if ((this.referenceNumber != undefined) && (this.referenceNumber != ''))
            {
              this.customerRequestsService.requestSummary(this.referenceNumber, this.translateService.instant('REQUEST_PHONE_CHANGE_HEADING'), requestSummaryList)
            
              this.router.navigate(['/request-list'])
            }	
                          
            this.formSubmitted = false
          },
          error: (error) =>
          {
            this.messageService.completedHttpRequest('submitForm')
      
            const dialogConfig = new MatDialogConfig()
            dialogConfig.width = '500px',
            dialogConfig.data = {
              title: this.translateService.instant('COMMON_LBL_ERROR'),
              message: this.translateService.instant('COMMON_LBL_ERROR_MSG')
            }		
            this.dialog.open(ErrorMessageModalComponent, dialogConfig)
          },
          complete: () =>
          {
            this.messageService.completedHttpRequest('submitForm')
          }
        })
      }
    })	
  }

  homePhoneValidator(event: any) 
	{
		const pattern = /^[0-9]*$/;   
		if (!pattern.test(event.target.value)) 
		{
			event.target.value = event.target.value.replace(/[^0-9]/g, "")
			this.request.homePhone = event.target.value
		}
	}

  businessPhoneValidator(event: any) 
	{
		const pattern = /^[0-9]*$/;   
		if (!pattern.test(event.target.value)) 
		{
			event.target.value = event.target.value.replace(/[^0-9]/g, "")
			this.request.businessPhone = event.target.value
		}
	}

  mobilePhoneValidator(event: any) 
	{
		const pattern = /^[0-9]*$/;   
		if (!pattern.test(event.target.value)) 
		{
			event.target.value = event.target.value.replace(/[^0-9]/g, "")
			this.request.mobilePhone = event.target.value
		}
	}
}
